import Link from 'next/link'

type DropdownButtonProps = {
  label: string
  onClick?: () => void
  href?: string
}

const DropdownButton = ({ label, onClick, href }: DropdownButtonProps) => {
  const baseStyles =
    'block w-[120px] px-5 py-2 text-sm text-pure-black dark:text-pure-white hover:bg-surface-light hover:dark:bg-surface-dark'

  if (href) {
    return (
      <Link href={href} className={baseStyles}>
        {label}
      </Link>
    )
  }

  return (
    <button
      id="dropdown-button"
      type="button"
      aria-label="dropdown-button"
      className={baseStyles}
      onClick={onClick}
    >
      {label}
    </button>
  )
}

export default DropdownButton
